import {
  selectAvailabilities,
  selectAvailabilitiesLoading,
  selectAvailabilityError,
  selectSelectedAvailabilities,
} from '../core/reducers/availability.reducer';

export const getAvailabilities = selectAvailabilities;
export const getAvailabilitiesLoading = selectAvailabilitiesLoading;
export const getAvailabilitiesError = selectAvailabilityError;
export const getSelectedAvailabilities = selectSelectedAvailabilities;
